import {
  TripRead,
  useTripsCancelReasonsRetrieveQuery,
} from 'src/common/external/bambi-api/bambiApi';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function useCancellationOptions(selectedTrip: TripRead | null) {
  const { data: cancelOptionsData } = useTripsCancelReasonsRetrieveQuery(
    {
      id: selectedTrip?.id || '',
    },
    {
      skip: !selectedTrip?.id,
    }
  );

  return {
    cancellationReasonOptions:
      cancelOptionsData?.cancel_reasons.map((reason) => {
        return {
          label: reason.label,
          value: reason.value || '',
        } as SelectOption;
      }) || [],
  };
}
